import React, { useState } from 'react';
import './EmailLinkModal.css';

const EmailLinkModal = ({ username, onMigrate, onSkip, isLoading, externalError }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  // Sync external error (e.g. from backend migration attempt)
  React.useEffect(() => {
    if (externalError) {
      setError(externalError);
    }
  }, [externalError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Vul a.u.b. een e-mailadres in of kies voor overslaan.');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Voer a.u.b. een geldig e-mailadres in.');
      return;
    }

    onMigrate(email);
  };

  return (
    <div className="delete-confirm-overlay" onClick={onSkip}>
      <div className="delete-confirm-modal auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="welcome-close-btn" onClick={(e) => { 
          e.preventDefault(); 
          e.stopPropagation(); 
          setTimeout(onSkip, 50); 
        }}>×</button>
        
        <h2>Account Beveiligen</h2>
        <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '1rem', textAlign: 'center' }}>
          Veiliger en makkelijker inloggen
        </p>

        <p style={{ color: '#4b5563', fontSize: '0.9rem', marginBottom: '1rem' }}>
          Welkom <strong>{username}</strong>! Je bent nu ingelogd. Koppel een e-mailadres om je account te beveiligen en makkelijker in te loggen in de toekomst.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">
              Nieuw E-mailadres:
              <span className="info-icon-container">
                <span className="info-icon">i</span>
                <span className="info-tooltip">
                  Na de koppeling kun je inloggen met zowel je e-mailadres als je oude gebruikersnaam.
                </span>
              </span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="jouw@email.nl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              required
            />
            {error && <span style={{ display: 'block', marginTop: '4px', color: '#ef4444', fontSize: '0.75rem', fontWeight: '600' }}>{error}</span>}
          </div>

          <button 
            type="submit" 
            className="submit-button success" 
            style={{ width: '100%', marginTop: '0.5rem' }}
            disabled={isLoading}
          >
            {isLoading ? 'Laden...' : 'E-mail Koppelen & Verder'}
          </button>
          
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <button 
              type="button" 
              className="link-button" 
              onClick={onSkip}
              disabled={isLoading}
              style={{ fontSize: '0.85rem' }}
            >
              Nu Overslaan
            </button>
          </div>
        </form>

        <p style={{ marginTop: '1rem', marginBottom: '0', fontSize: '0.75rem', color: '#999', textAlign: 'center' }}>
          Geen zorgen, we gebruiken je e-mail alleen voor beveiliging en accountbeheer.
        </p>
      </div>
    </div>
  );
};

export default EmailLinkModal;
